<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pageAgeCategories.title') }}
    </portal>
    <template v-if="ageCategories !== null">
      <card :title="$t('admin.pageAgeCategories.card.ageCategories')" cols="12">
        <hm-card-inner :full-size="true">
          <hm-col cols="12">
            <hm-card-inner-line v-for="ageCategory in ageCategories"
                                v-if="!ageCategory.deleted"
                                :title="getName(ageCategory)"
                                :clickable="true"
                                :key="ageCategory.id"
                                @click="routeToAgeCategory(ageCategory)" />
          </hm-col>
        </hm-card-inner>
      </card>

      <card v-if="!isEmpty(deletedAgeCategories)" :title="$t('admin.pageAgeCategories.card.deletedAgeCategories')" card-type="collapsible">
        <hm-card-inner :full-size="true">
          <hm-card-inner-line v-for="ageCategory in deletedAgeCategories"
                              :title="getName(ageCategory)"
                              :clickable="true"
                              :key="ageCategory.id"
                              @click="routeToAgeCategory(ageCategory)" />
        </hm-card-inner>
      </card>
    </template>

    <hm-floating-buttons id="actions" ref="floatingButtons">
      <hm-floating-button :label="$t('admin.pageAgeCategories.actions.more')" icon="plus" color="blue">
        <hm-floating-child-button :label="$t('admin.pageAgeCategories.actions.addAgeCategory')" icon="plus" color="blue" @click="addAgeCategory()" />
      </hm-floating-button>
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import { cloneDeep, groupBy, isEmpty, isNil, maxBy, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';

export default {
  name: 'PageAgeCategories',

  mixins: [HotelmeisterMixin, SaveWatchMixin],

  data() {
    return {
      ageCategories: null,
    };
  },

  computed: {
    deletedAgeCategories: function () {
      return isNil(this.ageCategories) ? null : this.ageCategories.filter(it => it.deleted === true);
    },
    maxAge: function () {
      return isNil(this.ageCategories) ? 0 : Math.max(0, maxBy(this.ageCategories.filter(it => it.deleted === false), 'ageUntil').ageUntil + 1);
    },
  },

  watch: {
  },

  created: function () {
    this.loadData();
  },

  updated() {
  },

  beforeDestroy() {
  },

  methods: {
    loadData() {
      this.axios.get(this.serviceUrls.ageCategory.list(this))
        .then((response) => {
          this.ageCategories = sortBy(response.data.data, ['ageFrom', `name.${this.hotelSettings.details.primaryLanguage}`]);
          this.$serviceBus.$emit('ageCategory.list', this.ageCategories);
        });
    },
    addAgeCategory() {
      this.axios.post(this.serviceUrls.ageCategory.list(this), {
        name: {
          [this.hotelSettings.details.primaryLanguage]: this.$t('admin.pageAgeCategories.newAgeCategoryName'),
        },
        ageFrom: this.maxAge,
        ageUntil: this.maxAge + 1,
        ageQualifier: 'Child',
      })
        .then((response) => {
          this.loadData();
          this.$serviceBus.$emit('hotelSettings.update');
        })
        .catch((error) => {
          if (isNil(error.response)) this.showErrorMessage();
          this.showMessages(error.response);
        });
    },
    getName(ageCategory) {
      const name = isNil(ageCategory) ? null : ageCategory.name;
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      let details = '';

      if (ageCategory.deleted === false && ageCategory.ageQualifier !== 'Adult') {
        details += `, ${ageCategory.ageFrom} - ${ageCategory.ageUntil} ${this.$t('admin.pageAgeCategories.lineDescriptionAgeYears')}`;
      }

      if (!isNil(ret)) {
        ret = ret.trim();
      }

      if (isEmpty(ret)) {
        ret = '-';
      }

      ret = `${ret}<span class="color--gray">${details}</span>`;

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeToAgeCategory(ageCategory) {
      this.$router.push({
        name: 'ageCategory',
        params: {
          ageCategoryId: ageCategory.id,
        },
      });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PageAgeCategories.vue